import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Loading } from '@cordata/buffet';

import { authorizedInstance } from '~/utils';

const DESTINATION_NAME = 'Kickstarter(legacy)';

const findLegacyUrl = destinations =>
  destinations?.find(({ name }) => name === DESTINATION_NAME)?.url;

const LegacyKickstarterRedirect = ({ hash }) => {
  useEffect(() => {
    const go = (destinations) => {
      const url = findLegacyUrl(destinations);

      if (url) window.location.replace(`${url}/#${hash}`);
    };

    const cached = JSON.parse(localStorage.getItem('destinations'));

    if (findLegacyUrl(cached)) {
      go(cached);

      return;
    }

    // the cache is populated asynchronously on app mount, so a direct deep link
    // can land here before it exists
    authorizedInstance
      .get('/destinations')
      .then(r => r.data.data)
      .then((r) => {
        localStorage.setItem('destinations', JSON.stringify(r));

        go(r);
      });
  }, [hash]);

  return (
    <Loading message="Redirecting to Kickstarter (legacy)" />
  );
};

LegacyKickstarterRedirect.propTypes = {
  hash: PropTypes.string.isRequired,
};

export default LegacyKickstarterRedirect;
